const properties = Object.freeze({
  Publisher: "Casa Editorial",
  Author: "Autor",
  ReadingMedium: "Medio de Lectura",
  Isbn: "ISBN"
});
export default properties;